<!--label *ngIf="toolTipContent" class="tool-tip-label m-0" tool-tip-content="{{toolTipContent}}"><i class="material-icons">info_outline</i></label-->
<div class="ds-wrapper2 text-left" *ngIf="toolTipContent">
  <div [ngClass]="{ 'header-tooltip tooltip--bottom': toolTipContentBottom }" class="tooltip tooltip--light tooltip--left">
    <i class="icon-ico_tooltip emp-icon"></i>
    <div [ngClass]="{ 'header-tooltip-text': toolTipContentBottom }" class="tooltiptext text-left"><p [innerHTML]="toolTipContent"></p></div>
  </div>
</div>
